module.exports = __webpack_public_path__ + "img/b024e87.svg";